module.exports = __webpack_public_path__ + "img/迎賓車道圖.a16647ae.jpg";